<template>
    <el-form :model="mgmtArea" :rules="mgmtAreaRules" :label-position="'left'" ref="mgmtAreaInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="name">
                        <el-input v-model="mgmtArea.name"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">分类编码</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="code">
                        <el-input v-model="mgmtArea.code"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="">说明：</label>
                </div>
                <div class="form-value width-2x">
                    <el-input type="textarea" v-model="mgmtArea.desc"></el-input>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getAssetKindList } from '../retailer/asset-comn'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-retailer-mgmt-area-save',
        desc: '',
        props: ["item"],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                mgmtArea: {},
                mgmtAreaRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    code: [{validator: checkNull, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            let self = this;
            let item = self.item;
            if(!Utils.isNoB(item)) {
                self.mgmtArea = Utils.merge({}, item);
            }
        },
        methods: {
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: "warn"
                };
                this.$refs['mgmtAreaInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.mgmtArea;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/bizArea/RetailerMgmtAreaSave.vue